export const ROLES = {
  agent: 'agent',
  dev: 'dev',
  admin: 'admin',
  superAdmin: 'super-admin',
};

export const SCOPES = {
  canCreate: 'can-create',
  canEdit: 'can-edit',
  canDelete: 'can-delete',
  canUse: 'can-use',
  canView: 'can-view',
  canDownload: 'can-download',
};

export const PERMISSIONS = {
  [ROLES.agent]: {
    admin: [SCOPES.canView],
    studio: [
      SCOPES.canView,
      SCOPES.canCreate,
      SCOPES.canEdit,
      SCOPES.canDelete,
    ],
  },
  [ROLES.dev]: {
    admin: [SCOPES.canView, SCOPES.canUse],
    studio: [
      SCOPES.canView,
      SCOPES.canCreate,
      SCOPES.canEdit,
      SCOPES.canDelete,
      SCOPES.canUse,
    ],
  },
  [ROLES.admin]: {
    admin: [SCOPES.canView, SCOPES.canUse, SCOPES.canDownload],
    studio: [
      SCOPES.canView,
      SCOPES.canCreate,
      SCOPES.canEdit,
      SCOPES.canDelete,
      SCOPES.canUse,
      SCOPES.canDownload,
    ],
  },
  [ROLES.superAdmin]: {
    admin: [
      SCOPES.canView,
      SCOPES.canCreate,
      SCOPES.canEdit,
      SCOPES.canDelete,
      SCOPES.canUse,
      SCOPES.canDownload,
    ],
    studio: [
      SCOPES.canView,
      SCOPES.canCreate,
      SCOPES.canEdit,
      SCOPES.canDelete,
      SCOPES.canUse,
      SCOPES.canDownload,
    ],
  },
};
